// extracted by mini-css-extract-plugin
module.exports = {"inline":"Variation_inline__3rhc1","percent":"Variation_percent__eNU0l"};